// Pet age: DOB is the primary source; otherwise years + months are entered (backend stores the
// recording date so the age advances). age_dob = backend's single basis for the current age.
const DOB = /^\d{4}-\d{2}-\d{2}/;

export function monthsSince(iso) {
  if (!iso || !DOB.test(iso)) return null;
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  const n = new Date(Date.now() + 330 * 60000);
  const mo = (n.getUTCFullYear() - y) * 12 + (n.getUTCMonth() + 1 - m) - (n.getUTCDate() < d ? 1 : 0);
  return mo < 0 ? null : mo;
}

export function ageText(months) {
  if (months == null) return "";
  const y = Math.floor(months / 12), m = months % 12;
  const ys = y ? `${y} year${y === 1 ? "" : "s"}` : "";
  const ms = m || !y ? `${m} month${m === 1 ? "" : "s"}` : "";
  return [ys, ms].filter(Boolean).join(", ");
}

export const petCurrentMonths = (p = {}) => monthsSince(p.age_dob) ?? monthsSince(p.dob);

export function petAgeError(v = {}) {
  if (v.dob && DOB.test(v.dob)) return "";
  const y = v.age_years, m = v.age_months;
  if ((y == null || y === "") && (m == null || m === "")) return `Enter ${v.name ? `${v.name}'s` : "the pet's"} age (years and months) or date of birth`;
  if (y != null && y !== "" && (!Number.isInteger(Number(y)) || Number(y) < 0 || Number(y) > 40)) return "Age in years must be a whole number from 0 to 40";
  if (m != null && m !== "" && (!Number.isInteger(Number(m)) || Number(m) < 0 || Number(m) > 11)) return "Months must be between 0 and 11";
  return "";
}

// Prefill for edit forms: current age (advanced) when no DOB.
export function agePrefill(p = {}) {
  if (p.dob && DOB.test(p.dob)) return { age_years: null, age_months: null };
  const mo = monthsSince(p.age_dob);
  return mo == null ? { age_years: null, age_months: null } : { age_years: Math.floor(mo / 12), age_months: mo % 12 };
}
